import Masonry from 'masonry-layout';

const grid = () => {
  const elem = document.querySelector('.b-showcase');
  if (elem) {
    // eslint-disable-next-line no-unused-vars
    const msnry = new Masonry(elem, {
      itemSelector: '.c-tease--showcase',
      columnWidth: 1,
      gutter: 100,
    });
  }
};

const hover = () => {
  const html = document.querySelector('html');

  if (!html.classList.contains('touch')) {
    const cases = document.querySelectorAll('.c-tease--showcase');

    if (cases.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < cases.length; i++) {
        const img = cases[i].querySelector('.c-img');
        const overlay = cases[i].querySelector('.c-tease__overlay');

        img.onmouseenter = () => {
          overlay.classList.add('c-tease__overlay--moving');
        };

        img.onmouseleave = () => {
          overlay.classList.remove('c-tease__overlay--moving');
        };

        img.onmousemove = e => {
          overlay.style.transform = `matrix(1, 0, 0, 1, ${e.clientX}, ${
            e.clientY
          })`;
        };
      }
    }
  }
};

const init = () => {
  grid();
  hover();
  // eslint-disable-next-line no-undef
  jQuery(document).on('facetwp-loaded', () => {
    grid();
    hover();
  });
};

export default { init, grid };



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/showcase.js